module.exports = __webpack_public_path__ + "static/media/landing-mockup.973bc54a.png";